export default __webpack_public_path__ + "static/media/model3.8aa2dac9.jpg";